// Verb for a moving subject's marker badge. Only vehicles say Driving; a phone
// rides in cars too, so a person never says Walking.
export function motionVerbFor(kind) {
    return kind === "vehicle" ? "Driving" : "Moving";
}
